import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useTranslation } from 'react-i18next';



export default function PlaybookFeatures() {
    const { t } = useTranslation();
    const FEATURES = [
        {
            icon: '🔗',
            title: t('PlaybookFeatures00'),
            subtitle: t('PlaybookFeatures01'),
            description: t('PlaybookFeatures02'),
            color: '#048cec'
        },
        {
            icon: '📄',
            title: t('PlaybookFeatures03'),
            subtitle: t('PlaybookFeatures04'),
            description: t('PlaybookFeatures05'),
            color: '#fca444'
        },
        {
            icon: '📱',
            title: t('PlaybookFeatures06'),
            subtitle: t('PlaybookFeatures07'),
            description: t('PlaybookFeatures08'),
            color: '#10b981'
        }
    ];

    return (
        <Box
            component="section"
            sx={{
                py: { xs: 8, md: 12 },
                px: { xs: 2, md: 4 },
                backgroundColor: 'background.default',
            }}
        >
            <Container maxWidth="lg">
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'center',
                        gap: 4,
                        mb: 8,
                    }}
                >
                    <Typography
                        variant="overline"
                        sx={{
                            color: 'text.disabled',
                            fontFamily: 'Barlow, sans-serif',
                            fontSize: '0.875rem',
                            fontWeight: 600,
                            letterSpacing: '0.1em',
                        }}
                    >
                        {t('PlaybookFeatures09')}
                    </Typography>

                    <Typography
                        variant="h2"
                        sx={{
                            fontFamily: 'Barlow, sans-serif',
                            fontSize: { xs: '2.5rem', sm: '3rem', md: '3.2rem' },
                            fontWeight: 800,
                            lineHeight: 1.2,
                            color: '#1a202c',
                        }}
                    >
                        {t('PlaybookFeatures10')}
                        <Box
                            component="span"
                            sx={{
                                background: 'linear-gradient(90deg, #048cec 20%, #fca444 100%)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text',
                            }}
                        >
                            {` ${t('PlaybookFeatures11')} `}
                        </Box>
                    </Typography>

                    <Typography
                        sx={{
                            color: 'text.secondary',
                            maxWidth: 600,
                            fontFamily: 'Barlow, sans-serif',
                            fontSize: '1.1rem',
                            lineHeight: 1.6,
                        }}
                    >
                        {t('PlaybookFeatures13')}
                    </Typography>
                </Box>

                <Grid container spacing={{ xs: 3, md: 4 }}>
                    {FEATURES.map((feature, index) => (
                        <Grid item xs={12} md={4} key={index}>
                            <Card
                                sx={{
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    borderRadius: 3,
                                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                                    transition: 'all 0.3s ease',
                                    border: '1px solid rgba(0, 0, 0, 0.05)',
                                    '&:hover': {
                                        transform: 'translateY(-4px)',
                                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                                    },
                                }}
                            >
                                <CardContent
                                    sx={{
                                        p: { xs: 3, md: 4 },
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        textAlign: 'center',
                                        flexGrow: 1,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: 80,
                                            height: 80,
                                            borderRadius: '50%',
                                            backgroundColor: `${feature.color}15`,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '2.5rem',
                                            mb: 3,
                                            border: `2px solid ${feature.color}30`,
                                        }}
                                    >
                                        {feature.icon}
                                    </Box>

                                    <Typography
                                        variant="h3"
                                        sx={{
                                            fontFamily: 'Barlow, sans-serif',
                                            fontSize: { xs: '1.5rem', md: '1.75rem' },
                                            fontWeight: 700,
                                            color: '#1a202c',
                                            mb: 1,
                                        }}
                                    >
                                        {feature.title}
                                    </Typography>

                                    <Typography
                                        variant="overline"
                                        sx={{
                                            color: feature.color,
                                            fontFamily: 'Barlow, sans-serif',
                                            fontSize: '0.875rem',
                                            fontWeight: 600,
                                            letterSpacing: '0.1em',
                                            mb: 2,
                                        }}
                                    >
                                        {feature.subtitle}
                                    </Typography>

                                    <Typography
                                        sx={{
                                            color: 'text.secondary',
                                            fontFamily: 'Barlow, sans-serif',
                                            fontSize: '1rem',
                                            lineHeight: 1.6,
                                            flexGrow: 1,
                                        }}
                                    >
                                        {feature.description}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
}
